var map = {
	"./DE.svg": "./src/drc/assets/images/flags/DE.svg",
	"./EN.svg": "./src/drc/assets/images/flags/EN.svg",
	"./ES.svg": "./src/drc/assets/images/flags/ES.svg",
	"./FR.svg": "./src/drc/assets/images/flags/FR.svg",
	"./IT.svg": "./src/drc/assets/images/flags/IT.svg",
	"./JA.svg": "./src/drc/assets/images/flags/JA.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/drc/assets/images/flags sync recursive ^\\.\\/.*\\.svg$";